class SeminarBookingForm
{

    constructor()
    {
        this.form = document.querySelector('.seminar-details__booking__form');
        if (!this.form) {
            return;
        }

        this.init();
    }

    init()
    {
        // Modules package
        const modulesPackageCheckbox = document.getElementById('booking_modulePackage');
        if (modulesPackageCheckbox) {
            const toggleStyleOnElements = this.form.querySelectorAll('.seminar-details__booking__module [style*="display: none"]');
            const priceDisplay = this.form.querySelector('.seminar-details__booking__price');
            modulesPackageCheckbox.addEventListener('change', () => {
                toggleStyleOnElements.forEach((toggleStyleOnElement) => {
                    toggleStyleOnElement.style.display = modulesPackageCheckbox.checked ? 'block' : 'none';
                    if ('SELECT' === toggleStyleOnElement.tagName) {
                        toggleStyleOnElement.required = modulesPackageCheckbox.checked;
                    }
                });
                priceDisplay.querySelector('i').textContent = modulesPackageCheckbox.checked ? priceDisplay.getAttribute('data-package-price') : priceDisplay.getAttribute('data-default-price');
            });
        }

        // Booking applicant incl. copy function
        const bookingApplicantCheckbox = document.getElementById('booking_applicant');
        if (bookingApplicantCheckbox) {
            const bookingApplicantContainer = this.form.querySelector('.seminar-details__booking__applicant');
            bookingApplicantCheckbox.addEventListener('change', () => {
                bookingApplicantContainer.style.display = bookingApplicantCheckbox.checked ? 'block' : 'none';
                bookingApplicantContainer.querySelectorAll('[data-required]')?.forEach((bookingApplicantRequiredField) => {
                    bookingApplicantRequiredField.required = bookingApplicantCheckbox.checked;
                });
            });
            bookingApplicantContainer.querySelector('button')?.addEventListener('click', (e) => {
                e.preventDefault();
                bookingApplicantContainer.querySelectorAll('input, textarea')?.forEach((bookingApplicantField) => {
                    const copyFromFieldName = bookingApplicantField.name.replace('applicant', 'invoice');
                    console.log(copyFromFieldName);
                    const copiedValue = this.form.querySelector(`[name="${copyFromFieldName}"`)?.value;
                    bookingApplicantField.value = copiedValue;
                });
            });
        }
    }

}

export default SeminarBookingForm;